function hasWindow(): boolean {
  return typeof window !== 'undefined'
}

function safelyRead(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

function safelyWrite(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value)
  } catch {
    // Ignore storage failures to avoid blocking UX.
  }
}

function safelyRemove(storage: Storage, key: string): void {
  try {
    storage.removeItem(key)
  } catch {
    // Ignore storage failures to avoid blocking UX.
  }
}

export function readSessionItemWithLocalFallback(key: string): string | null {
  if (!hasWindow()) {
    return null
  }

  const sessionValue = safelyRead(window.sessionStorage, key)
  if (sessionValue !== null) {
    return sessionValue
  }

  const localValue = safelyRead(window.localStorage, key)
  if (localValue === null) {
    return null
  }

  safelyWrite(window.sessionStorage, key, localValue)
  safelyRemove(window.localStorage, key)
  return localValue
}

export function writeSessionItem(key: string, value: string): void {
  if (!hasWindow()) {
    return
  }

  safelyWrite(window.sessionStorage, key, value)
  safelyRemove(window.localStorage, key)
}

export function clearSessionItem(key: string): void {
  if (!hasWindow()) {
    return
  }

  safelyRemove(window.sessionStorage, key)
  safelyRemove(window.localStorage, key)
}
